import React from 'react'
import shape1 from "../assets/img/shape_1.png"
import shape2 from "../assets/img/shape_2.png"
import logo from "../assets/img/logo.svg"
import rocket from "../assets/img/rocket.svg"
import next_arrow from "../assets/img/next_arrow.svg"

const Thankyou = () => {
  return (
    <div>
      <section class="start_wrapper">
    <div class="bg_layer">
      <img src={shape1} alt="" class="shp_1"/>
      <img src={shape2} alt="" class="shp_2"/>
      <span class="blur_1"></span>
      <span class="blur_2"></span>
    </div>
    <div class="txt_layer">
      <div class="logo_block">
        <img src={logo} alt=""/>
      </div>
      <div class="ready_block">
        <div class="top_block">
          <img src={rocket} alt=""/>
          <h1>Thank You!</h1>
          <p>Submission Complete</p>
        </div>
       
      </div>
    </div>
  </section>
    </div>
  )
}

export default Thankyou
